import { useContext } from "react";
import Answer from "./Answer";
import { QuizContext } from "../contexts/quiz";

const Questions = () => {
  const [quizState, dispatch] = useContext(QuizContext);

  const corans =
    quizState.questions[quizState.currentQuestionIndex].correct_answer;

  return (
    <div>
      <div className="question">
        {quizState.questions[quizState.currentQuestionIndex].question}
      </div>
      <div className="answers">
        {quizState.answers.map((answer, index) => (
          <Answer
            ansvalue={answer}
            key={index}
            index={index}
            currentAnswer={quizState.currentAmswer}
            correctAnswer={corans}
            onSelectedAnswer={(answerText) => {
              dispatch({ type: "SELECT_ANSWER", payload: answerText });
            }}
          ></Answer>
        ))}
      </div>
    </div>
  );
};

export default Questions;
